'use strict';

// Abrir Chamado Opções Controller

var abrirChamadoMdl = angular.module('abrirChamadoMdl');
abrirChamadoMdl.controller('abrirChamadoSegmentosCtrl', abrirChamadoSegmentosCtrl);

abrirChamadoSegmentosCtrl.$inject = [
    '$scope',
    '$filter',
    '$state',
    '$stateParams',
    '$sessionStorage',
    '$localStorage',
    'notificacao',
    'segmentosApi'
];

function abrirChamadoSegmentosCtrl(
    $scope,
    $filter,
    $state,
    $stateParams,
    $sessionStorage,
    $localStorage,
    notificacao,
    segmentosApi) {

    // Objetos e Propriedades
    $scope.segmento = {};
    $scope.history = window.history;
    $scope.showForward = false;
    $scope.segmentos = $sessionStorage.segmentos || [];   
    $scope.carregarSegmentos = carregarSegmentos;
    $scope.acessarSegmento = acessarSegmento;
    $scope.alternarTipoLista = alternarTipoLista;
    $scope.retornar = $state.previous;
    $scope.atualizarSegmentos = atualizarSegmentos;    

    $scope.$storage = $localStorage.$default({
        tipoListaSegmento: 0
    });

    // Caso seja o promeiro acesso a página, iremos
    // carregar todos os segumentos disponivel para
    // o usuário navegar.
    if ($scope.segmentos.length == 0) {
        $scope.carregarSegmentos();
    }


    // Aqui vamos verificar se a propriedade grupoDeSuporteId foi
    // passada por paramentro, se sim entendemos que um dos itens
    // foi selecionado e então procuramos por seus subitens para
    // apresentar ao usuário.
    if (!_.isEmpty($stateParams.grupoDeSuporteId)) {

        // Vamos omitir os parametros nulos
        var params = _.omitBy($stateParams, _.isEmpty);

        // Busca o segmento na coleção de segmentos
        $scope.segmento = _.first($filter('buscar')($scope.segmentos, params));

        // Obém os subsegmentos do segmento encontrado
        $scope.segmentos = $scope.segmento.segmentos;

    }

    // Chamadas API

    /**
     * Carrega todos os grupos de suporte ativos de uma central 
     * de serviço com seus respectivos segmentos.
     */
    function carregarSegmentos() {
        return segmentosApi.listarSegmentos(function (segmentos) {
            $scope.segmentos = segmentos;
            $sessionStorage.segmentos = segmentos;
        }, function error(errorResponse) {
            notificacao.erroResponse(errorResponse);
        });
    }
    
    // Fim Chamadas API

    /**
     * Roteia o segmento selecionado pelo usuário até 
     * o destino correto.
     * 
     * @param object segmento
     */
    function acessarSegmento(segmento) {

        // No primeiro momento iremos verificamos se o segmento tem apenas um segmento
        // como filho e se esse segmento tem a propriedade canalDeAtendimentoId. Então
        // caso seja satifeito redirecionamos para a tela contendo os segmentos filhos.
        // Se não for satisfeito então verificamos se o segmento atual possui a propriedade
        // canalDeAtendimentoId, se satisfeito redirenamos para a tela de seguimentos filho
        // caso contrário redirecionamos para tela de abertura de chamado.
        if (_.isEqual(segmento.segmentos.length, 1) && !_.isNull(_.first(segmento.segmentos).canalDeAtendimentoId)) {
            $state.go('app.abrir-chamado', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.segmentos[0].grupoDeSuporteSegmentoId
            });
        } else if (segmento.canalDeAtendimentoId != null) {
            $state.go('app.abrir-chamado', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.grupoDeSuporteSegmentoId
            });
        } else {
            $state.go('app.abrir-chamado-segmentos', {
                grupoDeSuporteId: segmento.grupoDeSuporteId,
                grupoDeSuporteSegmentoId: segmento.grupoDeSuporteSegmentoId
            });
        }
    }

    /**
     * Define o tipo de apresentação dos 
     * segmentos.
     * 
     * @param string tipo
     */
    function alternarTipoLista(tipo) {
        $scope.$storage.tipoListaSegmento = tipo;
    }

    /**
     * Atualiza os segmentos
     */
    function atualizarSegmentos() {
        $scope.carregarSegmentos().$promise.then(function () {
            notificacao.sucesso('Cartões atualizados!');
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/abrir-chamado/abrir-chamado-segmentos-controller.js